import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithCurationDetailsHealthProvider, useCurationDetailsHealth] = createComponentHealth('CurationDetails');
